/**
 * Scroll Animations — Gumyum Theme
 * IntersectionObserver-based reveal animations
 */
(function() {
  'use strict';

  var selectors = [
    '.animate-on-scroll',
    '.animate-reveal',
    '.animate-fade-in',
    '.animate-slide-left',
    '.animate-slide-right',
    '.animate-scale-in',
    '.fade-up',
    '.fade-in',
    '.scale-in'
  ];

  // Respect reduced motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll(selectors.join(',')).forEach(function(el) {
      el.classList.add('is-visible');
    });
    return;
  }

  function initObserver() {
    var elements = document.querySelectorAll(selectors.join(','));
    if (elements.length === 0) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    elements.forEach(function(el) {
      observer.observe(el);
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }

  // Re-init for Shopify section rendering events
  document.addEventListener('shopify:section:load', initObserver);
})();
